import React, { useState } from "react";
import ReactModal from "react-modal";
import styled from "styled-components";

const LayoutHeader = styled.div`
  display: flex;
  height: 5rem;
  align-items: center;
  font-size: 2rem;
  border-bottom: solid 1px #ddd;
  box-sizing: border-box;
  padding: 1rem;
`;
const Layout = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 1.2rem;
  flex: 1;
`;
const LayoutMain = styled.div`
  flex: 1;
  overflow: auto;
  font-size: 1.2em;
  line-height: 1.5em;
`;
const LayoutButtons = styled.div`
  border-top: solid 1px #ddd;
  padding: 1rem;
  display: flex;
  justify-content: flex-end;
`;
const HeaderTitle = styled.div`
  flex: 1;
  font-weight: 300;
`;
const HeaderClose = styled.div``;

const CloseButton = styled.button`
  border: none;
  background-color: transparent;
  cursor: pointer;
  padding: 0.7rem;
  border-radius: 0.5rem;

  svg {
    display: block;
  }

  &:hover {
    background-color: #f2f2f2;
  }
`;

export interface ModalProps extends ReactModal.Props {
  title?: string;
  buttons?: React.ReactNode;
}

const Modal: React.FC<ModalProps> = ({ children, ...props }) => {
  return (
    <ReactModal
      style={{
        content: {
          width: "calc(100% - 10rem)",
          maxWidth: "70rem",
          maxHeight: "calc(100% - 10rem)",
          border: "solid 1px #ccc",
          boxShadow: "0 0 16px rgba(0,0,0,0.2)",
          margin: "0 auto",
          top: "auto",
          bottom: "auto",
          left: "auto",
          right: "auto",
          padding: "0",
        },
      }}
      shouldCloseOnOverlayClick={false}
      {...props}
    >
      <Layout>
        <LayoutHeader>
          <HeaderTitle>{props.title}</HeaderTitle>
          <HeaderClose>
            <CloseButton onClick={props.onRequestClose}>
              <svg height="24" viewBox="0 0 24 24" width="24">
                <path d="M0 0h24v24H0V0z" fill="none"></path>
                <path d="M18.3 5.71c-.39-.39-1.02-.39-1.41 0L12 10.59 7.11 5.7c-.39-.39-1.02-.39-1.41 0-.39.39-.39 1.02 0 1.41L10.59 12 5.7 16.89c-.39.39-.39 1.02 0 1.41.39.39 1.02.39 1.41 0L12 13.41l4.89 4.89c.39.39 1.02.39 1.41 0 .39-.39.39-1.02 0-1.41L13.41 12l4.89-4.89c.38-.38.38-1.02 0-1.4z"></path>
              </svg>
            </CloseButton>
          </HeaderClose>
        </LayoutHeader>
        <LayoutMain>{children}</LayoutMain>
        {!!props.buttons && <LayoutButtons>{props.buttons}</LayoutButtons>}
      </Layout>
    </ReactModal>
  );
};

export default Modal;
